import { gql } from "@apollo/client";

// List view only
const GET_CLIENT_ASSESSMENT_INVOICES = gql`
  query getClientAssessmentInvoices(
    $clientIdentifier: String!
    $sortBy: InvoiceSortBy
    $sortDirection: SortDirection
    $invoiceStatuses: [InvoiceProcessStatus]
    $skip: Int
    $take: Int
    $searchTerm: String
    $clientFilterType: ClientFilterType
  ) {
    invoices(
      clientIdentifier: $clientIdentifier
      sortBy: $sortBy
      sortDirection: $sortDirection
      invoiceStatuses: $invoiceStatuses
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      clientFilterType: $clientFilterType
    ) {
      totalCount
      items {
        id
        createdAt
        currencyCode
        dueDate
        invoiceDate
        invoiceNumber
        invoiceFileId
        modifiedAt
        totalAmountWithVat
        isCreditInvoice
        state {
          assessmentStatus
        }
        invoiceIssuer {
          client {
            id
            name
          }
        }
        invoiceRecipient {
          client {
            id
          }
          name
          clientIdentifier
        }
        state {
          processStatus
        }
        tags {
          invoiceTagId
          tag
        }
        latestAssessment {
          invoiceAssessmentId
          passed
          manualReviewRequired
        }
        hasDuplicateInvoices
      }
    }
  }
`;

export default GET_CLIENT_ASSESSMENT_INVOICES;
